<template>
<div>
  <div class="bk-gray-dark bk-gray-dark-margin" >
    <div class="logo-secret">
            <img src="../../assets/images/image-secretele-laptelui/sustinere-sistem.png" style="width: 40px; height: 48px">
        </div>
        <h3>Susțin sistemul imunitar</h3>
        <p>Oligozaharidele din laptele matern împiedică dezvoltarea infecțiilor prin blocarea agenților patogeni la care este expus copilul tău.</p>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">

</style>
